import buildStorageValues from './buildStorageValues.js';
async function createWalletId(_ref) {
  let {
    walletStorageService,
    paymentInfo
  } = _ref;
  // Create a new Wallet Id with current payment info.
  const currentPaymentsInfo = buildStorageValues({
    payload: paymentInfo
  });
  const options = {
    paymentInfo: currentPaymentsInfo
  };
  const response = await walletStorageService.setData(options);
  if (response?.id) {
    walletStorageService.setWalletId(response.id);
  }
  return response?.id;
}
export { createWalletId as default };
